//Meta Pixel 事件集中管理（元辰雲閣）
//  Pixel ID 寫死在 public/index.html，fbq 已自動 init + PageView
//  這支負責各種商業事件（Purchase / Lead / AddToCart 等）
//
//  使用：
//    import { trackPurchase } from "../../utils/meta-pixel";
//    trackPurchase({ productID: "digital_flow", productName: "流年之書", amount: 899 });
//
//  Meta Ads 建廣告時可依 content_ids 過濾、鎖定單一商品轉換事件

const safeFbq = (...args) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;
  try {
    window.fbq(...args);
  } catch (e) {
    console.warn("[MetaPixel] fbq 呼叫失敗:", e?.message);
  }
};

//購買成功：Meta 用來優化轉換廣告的主要事件
//  payload: { productID, productName, amount, orderID?, currency? }
//    productID：planID（例 digital_flow / digital_love / point_1000）
//    productName：顯示名（例「流年之書」「A-Point 儲值卡 1000 點」）
//    amount：NT$ 金額（Number）
//    orderID：（強烈建議帶）跟 server-side Meta CAPI 用同一個 ID → Meta 自動去重，不會重複計數
export const trackPurchase = ({
  productID,
  productName,
  amount,
  orderID,
  currency = "TWD",
}) => {
  if (!productID || !productName || !amount) {
    console.warn("[MetaPixel] trackPurchase 缺必要欄位", {
      productID,
      productName,
      amount,
    });
    return;
  }
  const params = {
    value: Number(amount),
    currency,
    content_name: String(productName),
    content_ids: [String(productID)],
    content_type: "product",
  };
  //fbq 的 eventID 傳在第 4 個 options 參數
  if (orderID) {
    safeFbq("track", "Purchase", params, { eventID: String(orderID) });
  } else {
    safeFbq("track", "Purchase", params);
  }
};

//未來可擴充的事件（都走同個 helper 模式）
//  export const trackLead = (payload) => safeFbq("track", "Lead", payload);
//  export const trackAddToCart = (payload) => safeFbq("track", "AddToCart", payload);
//  export const trackInitiateCheckout = (payload) => safeFbq("track", "InitiateCheckout", payload);
